// extracted by mini-css-extract-plugin
export var documentation = "_ij-1";
export var menu = "_ij-0";